import React from "react";
import { Button, CircularProgress } from "@mui/material";

function AppButton({
  label = "",
  children = null,
  onClick = () => {},
  startIcon = null,
  variant = "contained",
  size = "small",
  bgColor = "#0070C2",
  className = "",
  fullWidth = false,
  type = "button",
  isLoading = false,
  loadingText = "Loading...",
  ...rest
}) {
  const baseClass =
    "!h-[28px] !p-0 !px-3 !text-[12px] !leading-normal !rounded-[4px] whitespace-nowrap !shadow-none disabled:!cursor-default disabled:!opacity-60 !flex !items-center !justify-center";
  const content = children ?? label;
  const getBackgroundColor = () => {
    if (variant !== "contained") return undefined;
    if (isLoading || rest.disabled) {
      return "#94a3b8";
    }
    return bgColor;
  };
  return (
    <Button
      variant={variant}
      size={size}
      type={type}
      fullWidth={fullWidth}
      onClick={onClick}
      startIcon={!isLoading ? startIcon : null}
      className={`${baseClass} ${className}`}
      sx={{
        minWidth: 0,
        minHeight: 0,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        lineHeight: "normal",
        WebkitFontSmoothing: "antialiased",
        padding: "0 12px",
        "& .MuiButton-label": {
          display: "flex",
          alignItems: "center",
        },
        "& .MuiButton-startIcon": {
          margin: "0",
          marginInlineEnd: "8px",
          marginInlineStart: "-2px",
          display: "flex",
          alignItems: "center",
          height: "100%",
        },
        "& .MuiButton-endIcon": {
          marginInlineStart: "8px",
          marginInlineEnd: "-2px",
        },
        "&.Mui-disabled": {
          backgroundColor:
            variant === "contained" ? `${bgColor} !important` : "transparent",
          color: "rgba(255, 255, 255, 0.7)",
          opacity: 0.6,
        },
      }}
      style={{
        backgroundColor: variant === "contained" ? bgColor : undefined,
      }}
      // style={{
      //   backgroundColor:
      //     variant === "contained" && !isLoading ? bgColor : undefined,
      // }}
      disabled={Boolean(isLoading || rest.disabled)}
      {...rest}
    >
      {isLoading ? (
        <span className="flex items-center justify-center gap-2">
          <CircularProgress size={18} thickness={4} style={{ color: "#fff" }} />
          <span className="text-white">{loadingText}</span>
        </span>
      ) : (
        content
      )}
    </Button>
  );
}

export default AppButton;
